import React, { useState } from "react";
import type { FormattedInvoicePayload } from "../../../formattedInvoice/formattedInvoiceData";
import type { InternalConditionalSession } from "../internalConditionalSession";
import styles from "./ReportDesignerPage.module.css";

export default function InternalConditionalTools({ payload, session, sampleIndex, setSampleIndex, onReopen }: {
  payload: FormattedInvoicePayload; session: InternalConditionalSession; sampleIndex: number;
  setSampleIndex: (index: number) => void; onReopen: (json: string) => void;
}) {
  const [serialized, setSerialized] = useState("");
  return <div className={styles["designer-internal-tools"]}>
    <strong>Internal in-memory conditional authoring</strong>
    <small>Design shows controlled structure; Preview evaluates shared rules. Renderer capability is internal only. Backend Save / Copy / Execute and customer availability remain disabled.</small>
    {session.samples.length > 0 && <label>Controlled fixture state <select aria-label="Controlled fixture state" value={sampleIndex} onChange={event => setSampleIndex(Number(event.target.value))}>{session.samples.map((sample, index) => <option value={index} key={sample.id}>{sample.label}</option>)}</select></label>}
    <details><summary>Canonical fixture round-trip (memory only)</summary>
      <button className={styles["designer-tool-btn"]} type="button" onClick={() => setSerialized(JSON.stringify(payload, null, 2))}>Serialize fixture</button>
      <button className={styles["designer-tool-btn"]} disabled={!serialized} type="button" onClick={() => onReopen(serialized)}>Reopen serialized fixture</button>
      <textarea aria-label="Canonical serialized fixture" readOnly value={serialized} />
    </details>
  </div>;
}
